import { FESTIVAL_TYPE } from "../../types";

export const festivalStyles = {
  [FESTIVAL_TYPE.WONDER]: {
    intro: "lg:pt-[58px] md:pt-[45px] pt-3",
    wrapper: "lg:max-w-[936px] sm:max-w-[656px]",
    leftImage:
      "relative mb-[13px] sm:mb-0 w-[360px] h-[138px] md:w-[388px] sm:w-[216px] md:h-[272px] sm:h-[232px]",
    leftImageParent:
      "md:w-[450px] md:basis-[450px] sm:w-[216px] sm:basis-[216px]",
  },
  [FESTIVAL_TYPE.PERCENT]: {
    intro: "lg:pt-[58px] md:pt-[45px] pt-3",
    wrapper: "max-w-[1366px] xl:pr-[200px] sm:pr-[15%] w-full !flex-1",
    leftImage:
      "relative w-[131px] h-[143px] md:w-[265px] sm:w-[216px] md:h-[285px] sm:h-[232px] mx-auto ",
    leftImageParent: "flex-1 lg:hidden",
  },
  [FESTIVAL_TYPE.STEPPED_AMOUNT]: {
    intro: "lg:pt-[15px] md:pt-3 pt-0",
    wrapper: "pr-5 sm:pr-8 lg:pr-[56px]",
    leftImage:
      "relative w-[131px] h-[143px] md:w-[265px] sm:w-[216px] mdm:h-[285px] sm:h-[232px] mx-auto",
    leftImageParent: "",
  },
  [FESTIVAL_TYPE.STEPPED_COUNT]: {
    intro: "lg:pt-[15px] md:pt-3 pt-0",
    wrapper: "pr-5 sm:pr-8 lg:pr-[56px]",
    leftImage:
      "relative w-[131px] h-[143px] md:w-[265px] sm:w-[216px] md:h-[285px] sm:h-[232px] mx-auto",
    leftImageParent: "",
  },
};
